/* ================================================================ */
// LAYOUT CONFIG VALIDATION | LayoutConfig.js
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import {LayoutTypes, AlignmentTypes} from '@myglobe/core/dist/types';
import { isNullOrUndefined } from 'util';
/* ========================================== */
/**
 * Layout Config Validator
 * -----------------------
 * Validates layout configuration against layout types and alignment
 * settings
 *
 * @param {*} propValue
 * @param {*} key
 * @param {*} componentName
 * @param {*} location
 * @param {*} propFullName
 */
function LayoutConfig(propValue, key, componentName, location, propFullName) {
    // Check Layout config
    const layoutConfig = propValue[key];
    if(!isNullOrUndefined(layoutConfig)) {
        if (
            // Invalid object check
            (typeof layoutConfig !== 'object') ||
            // Missing prop 'type' check
            !Object.prototype.hasOwnProperty.call(layoutConfig, 'type') ||
            // Invalid Layout Type
            !Object.values(LayoutTypes).includes(layoutConfig.type) ||
            // Invalid Grid Layout config check
            (layoutConfig.type === LayoutTypes.GRID &&
                (
                    !Object.prototype.hasOwnProperty.call(layoutConfig, 'align')
                    || !Object.values(AlignmentTypes).includes(layoutConfig.align)
                )
            )
        ) {
            // Invalid Layout Configuration
            console.debug('LayoutConfig | ', 'LayoutConfig invalid - ', 'layoutConfig:', layoutConfig);
            return new Error(`Invalid prop ${propFullName} passed to ${componentName}. Expected a valid layout configuratiom.`);
        }
    }
};
export default LayoutConfig;